
// escapes '</script>' and handles u2028 and u2029 line terminators
// http://stackoverflow.com/questions/66837/when-is-a-cdata-section-necessary-within-a-script-tag/1450633#1450633
// http://timelessrepo.com/json-isnt-a-javascript-subset
//
// NOTE: this is a fork of https://github.com/mapbox/safer-stringify/tree/5b296e4a684c746adcda4c697037c3ce802da7b9
// since fixes after version 0.0.1 aren't pushed to npm there yet as of writing
export default function saferStringify(obj, replacer, space) {
  return JSON.stringify(obj, replacer, space)
    .replace(/\//g, '\\/')
    .replace(/\u2028/g, '\\u2028').replace(/\u2029/g, '\\u2029');
}



// WEBPACK FOOTER //
// ./src/util/safer-stringify.js